import { isMobile } from './isMobile';
const bezier = {
	x1: 0.5,
	y1: 0.2,
	x2: 0.25,
	y2: 1,
};
export class AutoChange {
	constructor(_snap) {
		Object.defineProperty(this, '_snap', {
			enumerable: true,
			configurable: true,
			writable: true,
			value: _snap,
		});
		Object.defineProperty(this, '_isEnabled', {
			enumerable: true,
			configurable: true,
			writable: true,
			value: true,
		});
	}
	destroy() {
		this.disable();
	}
	disable() {
		this._isEnabled = false;
		this._snap.cancelTransition();
	}
	enable() {
		if (!isMobile()) {
			this.disable();
			return;
		}
		if (this._snap.isTransitioning && this._isEnabled) {
			return;
		}
		if (this._snap.isSwiping) {
			return;
		}
		this._snap.cancelTransition();
		this._isEnabled = true;
		this._snap.next({
			duration: 2000,
			easing: [bezier.x1, bezier.y1, bezier.x2, bezier.y2],
			onEnd: () => {
				if (this._isEnabled) {
					setTimeout(() => {
						this.enable();
					}, 0);
				}
			},
		});
	}
}
